<!-- week days -->
<div class="kal-day-calendar__letter">
  <div *ngFor="let day of narrowWeekDays"> {{ day }}</div>
</div>

<div class="kal-day-calendar__number">

  <button *ngFor="let date of daysList"
          type="button"
          [class.kal-other-month-day]="isDateFromAnotherMonth(date)"
          [class.kal-today]="date.isToday()"
          [class.kal-active]="isDayActivated(date)"
          [class.kal-selected]="date.isSame(currentDate)"
          [disabled]="shouldDisable(date)"
          [ngClass]="getClassesForDate(date)"
          (click)="pickDate($event, date)">
    {{ date.getDay() }}
  </button>

</div>
